/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SubmitCaseImage = {
    imageObjectKey?: string;
    imageType?: SubmitCaseImage.imageType;
};
export namespace SubmitCaseImage {
    export enum imageType {
        BODY = 'BODY',
        WITH_IMEI_OR_SN = 'WITH_IMEI_OR_SN',
        WITH_SETTINGS_SCREEN = 'WITH_SETTINGS_SCREEN',
    }
}

